let credential;


export async function logout() {
    return new Promise((resolve, reject) => {
        FirebasePlugin.signOutUser(function() {
            console.log("User signed out");
            resolve();
        }, function(error) {
            console.error("Failed to sign out user: " + error);
            reject(error);
        });
    });
}

export async function sendSms(phoneNumber) {
    return new Promise(async (resolve, reject) => {
        var timeOutDuration = 60;
        // var fakeVerificationCode = '123456';
        // var awaitingSms = false;
  
        FirebasePlugin.verifyPhoneNumber(function (cred) {
          console.log(cred)
          // if (credential.instantVerification) {
          //   if (awaitingSms) {
          //     awaitingSms = false;
          //     // the Android device used auto-retrieval to extract and submit the verification code in the SMS so dismiss user input UI
          //     dismissUserPromptToInputCode();
          //   }
          //   signInWithCredential(credential);
          // } else {
          // awaitingSms = true;
          // promptUserToInputCode() // you need to implement this
          // .then(function (userEnteredCode) {
          //   awaitingSms = false;
          //   credential.code = userEnteredCode; // set the user-entered verification code on the credential object
          //   signInWithCredential(credential);
          // });
          // }
          
          credential = cred;
          resolve(cred)
        }, function (error) {
          console.error("Failed to verify phone number: " + JSON.stringify(error));
          reject(error)
        }, phoneNumber, timeOutDuration);
  
    });
}

export async function verifyCode(code, authStateChanged) {
    return new Promise(async (resolve, reject) => {
        if (!credential) return reject("Credential is null.");

        credential.code = code;
        FirebasePlugin.signInWithCredential(
            credential,
            function () {
                console.log("Successfully signed in");
                FirebasePlugin.getCurrentUser(authStateChanged, function (error) {
                    console.error("Failed to get current user data: " + error);
                    reject(error);
                });
                resolve(true);
            },
            function (error) {
                console.error("Failed to sign in", error);
                reject();
            }
        );
    });
}

function getCurrentUser(cb) {
    FirebasePlugin.getCurrentUser((u) => {
        console.log('got user: ')
        console.log(u)
        cb(u);
    }, function (error) {
        console.error("Failed to get current user data: " + error);
    });
}

export function listenToAuthState(authStateChanged) {
    FirebasePlugin.registerAuthStateChangeListener((userSignedIn) => {
        if (!userSignedIn) return;
        getCurrentUser(authStateChanged);
    });

    // This is for when page loads and user already signed in
    getCurrentUser(authStateChanged);
}